import React, { useEffect, useRef } from "react";
export const InlineResultBox = ({ html }) => {
    const scrollerRef = useRef();
    useEffect(() => {
        scrollerRef.current.scrollTop = scrollerRef.current.scrollHeight;
    }, [html.length, scrollerRef]);
    return (React.createElement("div", { className: "ai-popup__result", ref: scrollerRef },
        React.createElement("div", { className: "ProseMirror ProseMirror--display ai-popup__result-text", dangerouslySetInnerHTML: { __html: html } }),
        React.createElement("div", { className: "ai-popup__bottom" })));
};
